import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Input, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import InputMask from 'react-input-mask';
import 'react-datepicker/dist/react-datepicker.css';

import DatePicker from 'react-datepicker';
import moment from 'moment';
class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: [],
            datosDelete: [],
            porcentaje: null,
            persona_id: null,
            persona_nombre: "",
            total: 0,
            solicitud: null,
            proyecto_codigo: null,
            resumen: "",
            fechaFin: moment(),
            fechaInicio: moment(),
        };
    }



    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            datos: [],
            datosDelete: [],
            porcentaje: null,
            persona_id: null,
            persona_nombre: "",
            rol_id: null,
            rol_nombre: "",
            total: 0,
            solicitud: "",
            proyecto_codigo: "",
            resumen: "",
            fechaFin: moment(),
            fechaInicio: moment(),
        })
    }

    setSelects(data) {

        var total = 0;
        data.datos.forEach(x => total += x.porcentaje);
        this.setState({
            datos: data.datos,
            total: total,
            solicitud: data.solicitud_id,
            proyecto_codigo: data.codigo,
            resumen: (data.resumen != null ? data.resumen : ""),
            fechaInicio: (data.fechaInicio != null ? moment(data.fechaInicio) : moment()),
            fechaFin: (data.fechaFin != null ? moment(data.fechaFin) : moment()),
        });
    }

    AddToTable() {
        var datos = this.state.datos;

        var existdato = datos.filter(x => x.persona_id == this.state.persona_id && x.rol_id == this.state.rol_id);
        if (existdato.length > 0) {
            existdato[0].porcentaje += this.state.porcentaje;
        } else {
            datos.push({
                persona_id: this.state.persona_id,
                nombre: this.state.persona_nombre,
                rol_id: this.state.rol_id,
                rol_nombre: this.state.rol_nombre,
                porcentaje: this.state.porcentaje
            });
        }

        var total = 0;
        datos.forEach(x => total += x.porcentaje);

        this.setState({
            datos: datos,
            persona_id: 0,
            rol_id: 0,
            rol_nombre: "",
            persona_nombre: "",
            porcentaje: 0,
            total: total,
        })
    }

    onChangeInput(row, value) {
        var datos = this.state.datos;
        datos[row].porcentaje = parseInt(value);

        var total = 0;
        datos.forEach(x => total += x.porcentaje);
        if (total <= 100)
            this.setState({
                datos: datos,
                total: total
            });

    }

    removeRow(persona_id, rol_id) {
        var datos = this.state.datos.filter(x => x.persona_id != persona_id || x.rol_id != rol_id);
        var datosDelete = this.state.datosDelete;
        var newdatosDelete = this.state.datos.filter(x => x.persona_id == persona_id && x.rol_id == rol_id).filter(x => x.id != null).map(x => x.id);

        for (var i = 0; i < newdatosDelete.length; i++) {
            datosDelete.push(newdatosDelete[i]);
        }

        var total = 0;
        datos.forEach(x => total += x.porcentaje);
        this.setState({
            datos: datos,
            total: total,
            datosDelete
        });
    }

    changePorcentaje(e) {
        var value = parseInt(e.target.value);
        if (value > 0) {
            var total = 0;
            this.state.datos.forEach(x => total += x.porcentaje);
            if (total + value <= 100)
                this.setState({ porcentaje: value });
            else {
                this.setState({ porcentaje: 100 - total });
                e.preventDefault();
            }
        }
        else {
            this.setState({ porcentaje: 0 });
            e.preventDefault();
        }
    }

    render() {
        var atr = [];
        if (this.state.datos) {
            for (var i = 0; i < this.state.datos.length; i++) {
                let rowN = i.toString();
                let row = this.state.datos[i];
                atr.push(
                    <tr key={i}>
                        <td className="d-none">
                            <Input type="number" name={"datos[" + rowN + "][id]"} className="p-0 d-none" value={row.id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                            <Input type="number" name={"datos[" + rowN + "][persona_id]"} className="p-0 d-none" value={row.persona_id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                            <Input type="number" name={"datos[" + rowN + "][rol_id]"} className="p-0 d-none" value={row.rol_id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                        </td>
                        <td>
                            {row.nombre}
                        </td>
                        <td>
                            {row.rol_nombre}
                        </td>
                        <td>
                            <Input type="number" disabled={true} name={"datos[" + rowN + "][porcentaje]"} value={row.porcentaje} onChange={(e) => this.onChangeInput(rowN, e.target.value)} className="text-right" />
                        </td>
                    </tr>
                );
            }
        }



        return (
            <ParadigmaModal
                getUrl={api.proyectos.cargadatos.detail}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Detalle"}
                buttonTitle={"Ver Certificación"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-lg"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}>
                <Input type="hidden" name="DatosDelete" onChange={(e) => { return; }} value={this.state.datosDelete.join(',')}></Input>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Datos del proyecto</h5>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <label>Código</label>
                                <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Proyecto</label>
                                <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud} disabled={true} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <label>Fecha Inicio</label>
                                <DatePicker
                                    selected={this.state.fechaInicio}
                                    onChange={(e) => this.setState({ 'fechaInicio': e })}
                                    disabled={true}
                                    timeFormat=""
                                    className="form-control"
                                    name={"fechaInicio"}
                                    timeIntervals={15}
                                    dateFormat="DD/MM/YYYY"
                                    timeCaption="time"
                                    customInput={<InputMask name="fechaInicio" className="form-control" mask="99/99/9999" type="text" />}
                                />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <label>Fecha Fin</label>
                                <DatePicker
                                    selected={this.state.fechaFin}
                                    onChange={(e) => this.setState({ 'fechaFin': e })}
                                    disabled={true}
                                    timeFormat=""
                                    className="form-control"
                                    name={"fechaFin"}
                                    timeIntervals={15}
                                    dateFormat="DD/MM/YYYY"
                                    timeCaption="time"
                                    customInput={<InputMask name="fechaFin" className="form-control" mask="99/99/9999" type="text" />}
                                />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>

                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Participantes certificados</h5>
                        <table className="ui-table">
                            <thead>
                                <tr>
                                    <th className="d-none">QUITAR</th>
                                    <th>Persona</th>
                                    <th>Rol</th>
                                    <th className="text-right">Porcentaje</th>
                                </tr>
                            </thead>
                            <tbody>
                                {atr}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan="2">Total</th>
                                    <th>
                                        <Input type="number" className="text-right" disabled={true}
                                            onChange={(e) => { return; }} value={(this.state.total ? this.state.total : 0)}></Input>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </section>

                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Resumen</h5>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>
                                    Resumen <span className={(this.state.resumen.length > 1500 ? "ui-badge ui-badge-danger" : "ui-badge ui-badge-neutral")}>({this.state.resumen.length}/1500)</span>
                                </label>
                                <Input disabled={true} type="textarea" name="resumen" value={this.state.resumen} onChange={(e) => this.setState({ resumen: e.target.value })} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Consultas/Detail.js